import * as time from '@/libs/time'

export default {
  // ログインしているか
  authed (state) {
    return state.id > 0
  },

  // ユーザID
  id (state) {
    return state.id
  },

  // ユーザ名
  name (state) {
    return state.name
  },

  // 誕生日
  birthday (state) {
    return state.birthday
  },

  // 免許証取得日
  licenseAcquire (state) {
    return state.licenseAcquire
  },

  // 免許証有効期限
  licenseExpire (state) {
    return state.licenseExpire
  },

  // AT限定
  licenseAT (state) {
    return state.licenseAT
  },

  // Keykey が利用できるか
  keykey (state) {
    return state.services.keykey
  },

  // 制約事項
  limited (state) {
    return function (date) {
      // 初心者 判定
      const acquire = time.create(state.licenseAcquire)
      const beginnerDur = time.duration(date, acquire)
      const beginner = (beginnerDur < 1 * time.YEAR)

      // 未成年 判定
      const minorDur = time.duration(date, state.birthday)
      const minor = (minorDur < 20 * time.YEAR)

      // AT限定 判定
      const at = state.licenseAT

      // 初回利用 判定
      const firstTime = !state.services.repeater

      return {
        beginner,
        minor,
        at,
        firstTime
      }
    }
  }
}
